import { IScope, IPromise } from "angular";
import { StateService, TransitionService, StateParams } from "@uirouter/angularjs";
import { IModalService } from "angular-ui-bootstrap";
import { IHubFilter, IHubWorkflowActions } from "../../hub/models/hub";
import { IEmployee } from "@gtmhub/employees/models/models";
import { HubService } from "../../hub/services/hub";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { CurrentEmployeeActions, ICurrentEmployeeStoreState } from "@gtmhub/employees";
import { ITraceRootScopeService, Ng1Zone } from "@gtmhub/core/tracing";
import { INgRedux } from "@gtmhub/state-management";

class IHubFilterStateParams extends StateParams {
  teamIds?: string;
  employeeIds?: string;
  filterId?: string;
  filter?: any;
}

const mapStateToScope = (state: ICurrentEmployeeStoreState) => {
  const { info: currentEmployee } = state.currentEmployee;
  return {
    user: currentEmployee,
  };
};

export class HubFilterCtrl {
  currentState: string;
  filters: IHubFilter[];
  user: IEmployee;
  params: IHubFilterStateParams;
  filterModal: any;
  workflowActions: IHubWorkflowActions;
  showWorkflowLink: boolean;
  goalsToApprove: any[]; // todo :typecast this later

  public static $inject = ["$scope", "$transitions", "$state", "$uibModal", "HubService", "UIErrorHandlingService", "CurrentEmployeeActions", "$ngRedux", "$rootScope"];

  constructor(
    private $scope: IScope,
    private $transitions: TransitionService,
    private $state: StateService,
    private $uibModal: IModalService,
    private hubService: HubService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private currentEmployeeActions: CurrentEmployeeActions,
    private $ngRedux: INgRedux,
    private $rootScope: ITraceRootScopeService
  ) {
    this.params = this.$state.params;
    this.currentState = this.$state.current.name;

    this.$scope.$on("filtersChanged", () => this.onFiltersChanged());
    this.$scope.$on("goalsToApproveLoaded", (evt, goalsToApproveLoaded: any[]) => this.onGoalsToApproveLoaded(goalsToApproveLoaded));

    this.$scope.$on(
      "$destroy",
      this.$transitions.onSuccess({}, (trans) => this.onStateChangeSuccess(trans.router.globals.params))
    );

    const unsubscribe = this.$ngRedux.connect(mapStateToScope.bind(this))(this);
    this.$scope.$on("$destroy", unsubscribe);

    this.$rootScope.traceAction("hub_init", () => this.init(), Ng1Zone.root);
  }

  openFilterModal(): void {
    this.filterModal = this.$uibModal.open({
      templateUrl: require("../../assignees/views/filter-form.jade"),
      windowClass: "medium-small",
      controller: "FilterFormCtrl",
    });
  }

  private onGoalsToApproveLoaded = (goalsToApproveLoaded: any[]): void => {
    this.goalsToApprove = goalsToApproveLoaded;
  };

  private init(): IPromise<unknown> {
    this.$ngRedux.dispatch(this.currentEmployeeActions.fetchCurrentEmployeeIfMissing());

    return this.hubService.getFilters("hub").then(
      (filters) => {
        this.filters = filters as IHubFilter[];
      },
      (error) => this.uiErrorHandlingService.handleModal(error)
    );
  }

  private onStateChangeSuccess(toParams: IHubFilterStateParams) {
    this.currentState = this.$state.current.name;
    this.params = toParams;
  }

  private onFiltersChanged() {
    this.hubService.getFilters("hub").then(
      (filters: IHubFilter[]) => {
        this.filters = filters;
      },
      (error) => this.uiErrorHandlingService.handleModal(error)
    );

    if (this.filterModal) {
      this.filterModal.close();
    }
  }
}
